import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip"]

  disconnect() {
    this.tooltipTarget.classList.add("hidden")
  }

  onMove(event) {
    const label = event.currentTarget.dataset.label
    if (!label) return

    const rect = this.element.getBoundingClientRect()
    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    this.tooltipTarget.textContent = label
    this.tooltipTarget.classList.remove("hidden")
    const width = this.tooltipTarget.offsetWidth
    const left = x + 10 + width > rect.width ? x - 10 - width : x + 10
    this.tooltipTarget.style.left = `${Math.max(0, left)}px`
    this.tooltipTarget.style.top = `${y - 30}px`
  }

  onLeave() {
    this.tooltipTarget.classList.add("hidden")
  }
}
